"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteCreatePayableTransport = exports.WaysteUpdatePayableTransport = exports.WaystePayableTransport = exports.PayableUpdateTransport = exports.PayableCreateTransport = exports.PayableTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const invoice_transport_1 = require("./invoice-transport");
exports.PayableTransport = typebox_1.Type.Object({
    invoiceDetails: invoice_transport_1.InvoiceTransport,
    id: typebox_1.Type.String(),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    readyForPayment: typebox_1.Type.Boolean(),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.PayableCreateTransport = typebox_1.Type.Object({
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    invoiceDetails: invoice_transport_1.InvoiceCreateTransport,
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.PayableUpdateTransport = typebox_1.Type.Object({
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    readyForPayment: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    invoiceDetails: typebox_1.Type.Optional(invoice_transport_1.InvoiceUpdateTransport),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.WaystePayableTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    readyForPayment: typebox_1.Type.Boolean(),
    invoiceDetails: invoice_transport_1.InvoiceTransport,
});
exports.WaysteUpdatePayableTransport = typebox_1.Type.Object({
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    readyForPayment: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    invoiceDetails: typebox_1.Type.Optional(invoice_transport_1.InvoiceUpdateTransport),
});
exports.WaysteCreatePayableTransport = typebox_1.Type.Object({
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    invoiceDetails: invoice_transport_1.InvoiceCreateTransport,
});
//# sourceMappingURL=payable-transport.js.map